const guidRegEx = new RegExp(/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i);

export function isValidGuid(value) {
  if(!value) {
    return false;
  }
  return guidRegEx.test(value);
}



// WEBPACK FOOTER //
// src/common/guid-utilities.js